var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({staticClass:"button",class:{
            primary : this.primary,
            dark : this.dark,
            clickable : !this.disabled,
            disabled : this.disabled,
            pressed : this.pressed,
        },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.handleClick()}}},'button',_vm.$attrs,false),[_c('div',{staticClass:"button-content"},[(_vm.iconSrc)?_c('img',{staticClass:"icon",class:_vm.iconClass,attrs:{"src":_vm.iconSrc}}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }